import React from 'react';
import { Link } from 'react-router-dom';

interface AuthLayoutProps {
  children: React.ReactNode;
  isLogin: boolean;
}

const AuthLayout: React.FC<AuthLayoutProps> = ({ children, isLogin }) => {
  return (
    <div className="min-h-screen bg-trident-gray-50 flex items-center justify-center p-4 relative overflow-hidden">
      {/* Decorative background */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute -top-20 -right-20 w-96 h-96 bg-trident-orange/10 rounded-full blur-3xl" />
        <div className="absolute -bottom-20 -left-20 w-96 h-96 bg-trident-orange/5 rounded-full blur-3xl" />
      </div>

      <div className="relative max-w-5xl w-full bg-white rounded-3xl shadow-card-hover flex overflow-hidden border border-trident-gray-100">
        <div className="w-full md:w-1/2 p-8 md:p-12 flex flex-col justify-center">
          <div className="mb-8 flex items-center gap-3">
            <img src="/trident-logo.png" alt="itTrident" className="h-10 w-auto" />
            <div>
              <div className="font-display font-bold text-trident-gray-900 text-xl leading-tight">
                Blog <span className="text-trident-orange">Automation</span>
              </div>
              <div className="text-[10px] uppercase tracking-widest text-trident-gray-500 font-semibold">
                AI-Powered Content Pipeline
              </div>
            </div>
          </div>
          {children}
        </div>

        <div className="hidden md:flex w-1/2 bg-gradient-to-br from-trident-navy via-trident-navy-light to-trident-navy p-12 flex-col justify-center items-center text-center relative overflow-hidden">
          <div className="absolute inset-0 pointer-events-none opacity-30">
            <div className="absolute top-10 right-10 w-40 h-40 bg-trident-orange/20 rounded-full blur-2xl" />
            <div className="absolute bottom-10 left-10 w-52 h-52 bg-trident-orange/15 rounded-full blur-2xl" />
          </div>
          <div className="relative z-10 text-white">
            <div className="inline-block mb-6 px-4 py-1.5 rounded-full bg-white/10 backdrop-blur-sm border border-white/20">
              <span className="text-[11px] uppercase tracking-[3px] font-display font-bold text-trident-orange">
                {isLogin ? 'New to the platform?' : 'Already onboard?'}
              </span>
            </div>
            <h2 className="font-display text-4xl font-extrabold mb-4 leading-tight">
              {isLogin ? 'Ship blogs faster with AI.' : 'Welcome back!'}
            </h2>
            <p className="mb-10 text-white/80 text-sm leading-relaxed max-w-sm mx-auto">
              {isLogin
                ? 'From PDF topic briefs to published, SEO-optimized articles — automate your entire content pipeline.'
                : 'Continue shipping high-quality, AI-generated content for the itTrident website.'}
            </p>
            <Link
              to={isLogin ? '/register' : '/login'}
              className="inline-block bg-trident-gradient text-white px-8 py-3 rounded-xl font-display font-bold shadow-trident-lg hover:shadow-trident hover:-translate-y-0.5 transition-all duration-200"
            >
              {isLogin ? 'Create Account' : 'Sign In'}
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AuthLayout;
